export const AGENDA_SLOTS = [];
for (let h = 7; h <= 19; h++) {
  for (let m = 0; m < 60; m += 30) {
    if (h === 19 && m > 0) break;
    AGENDA_SLOTS.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
  }
}

export const fmtH = (t) => (t ? t.replace(':', 'h') : '');

export const fmtRange = (start, end) => {
  if (!start) return 'Journée';
  return end ? `${fmtH(start)} – ${fmtH(end)}` : fmtH(start);
};

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};
